import React, { Component } from "react"
import OutsideClickTrigger from "./OutsideClickTrigger"

class GenericModal extends Component {
  render() {
    return (
      <div className="overlay overlay--modal overlay--fixed is-active">
        <div className="modal">
          <OutsideClickTrigger
            onOutsideClick={() => {
              this.props.genericModalClose(this.props.genericModalCallback)
            }}
          >
            <React.Fragment>
              <button
                className="button button--icon js--close-modal"
                onClick={() => {
                  this.props.genericModalClose(this.props.genericModalCallback)
                }}
              >
                <span className="icon">
                  <svg className="svg-icon svg-icon--close-new">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
              <div className="modal__content">
                <div className="modal__content__inner">
                  {/* <div className="modal__top" dangerouslySetInnerHTML={{ __html: this.props.genericModalTop }}>
                  </div> */}
                  <div className="modal__middle rich-text" dangerouslySetInnerHTML={{ __html: this.props.genericModalBody }}></div>
                  {/* <div className="modal__bottom" dangerouslySetInnerHTML={{ __html: this.props.genericModalBottom }}>
                  </div> */}
                </div>
              </div>
            </React.Fragment>
          </OutsideClickTrigger>
        </div>
      </div>
    )
  }
}

export default GenericModal
